import { render, staticRenderFns } from "./imposto.vue?vue&type=template&id=7fd99208"
import script from "./imposto.vue?vue&type=script&lang=js"
export * from "./imposto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports